<script lang="ts">
    import {ModalDialogService} from 'shared/modal-dialogs';
    import {getInjector, getLocalization} from 'src/core';
    import {createSpecialSymbolsKeyboardAction} from 'shared/value-editors/internal/shared/use.special-symbols-keyboard';
    import {exists} from 'shared/utils/custom-utils';
    import KpContextMenuWrapper from 'shared/components/kp-context-menu/KpContextMenuWrapper.svelte';
    import KpContextMenuButton from 'shared/components/kp-context-menu/KpContextMenuButton.svelte';
    import KpContextMenuTextualActions from 'shared/components/kp-context-menu/KpContextMenuTextualActions.svelte';
    import KpHorizontalSeparator from 'shared/ui-widgets/separator/KpHorizontalSeparator.svelte';

    export let inputElement: HTMLInputElement | HTMLTextAreaElement;
    export let editorId: string;
    export let disabled = false;

    const modalDialogService = getInjector().tryGetByClass(ModalDialogService);
    const localize = getLocalization();

    const handleSpecialSymbolsClick = () => {
        if (!exists(modalDialogService)) {
            return;
        }

        modalDialogService.openModalWindow('specialSymbolsKeyboard', {inputRef: inputElement});
    }
</script>

<KpContextMenuWrapper id="{editorId}-context-menu" {disabled}>
    <svelte:fragment slot="context-content">
        <KpContextMenuTextualActions {inputElement}/>
        <KpHorizontalSeparator width="100%"/>

        <KpContextMenuButton on:click={handleSpecialSymbolsClick}>
            {localize(/* @kp-localization commons.InsertingSpecialCharactersButtonLabel */ 'commons.InsertingSpecialCharactersButtonLabel')}
        </KpContextMenuButton>
    </svelte:fragment>

    <slot specialSymbolsKeyboardAction={createSpecialSymbolsKeyboardAction(modalDialogService)}/>
</KpContextMenuWrapper>